const sanitizeTenantSlug = (value: string) => value.trim().toLowerCase().replace(/[^a-z0-9-]/g, "");

const normalizeHost = (value: string | undefined | null) => {
  const raw = String(value ?? "").trim().toLowerCase();
  if (!raw) return "";
  const withoutProto = raw.replace(/^https?:\/\//, "");
  const withoutPath = withoutProto.split("/")[0] ?? "";
  const withoutPort = withoutPath.split(":")[0] ?? "";
  return withoutPort.trim();
};

const env = (import.meta as { env?: Record<string, string | undefined> }).env ?? {};
const defaultTenantSlug = String(env.VITE_DEFAULT_TENANT_SLUG ?? "default").trim().toLowerCase() || "default";
const defaultTenantAliases = new Set(
  String(env.VITE_DEFAULT_TENANT_ALIASES ?? "")
    .split(",")
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean)
);
defaultTenantAliases.add("www");

const appRootDomain = normalizeHost(String(env.VITE_APP_ROOT_DOMAIN ?? env.VITE_APP_DOMAIN ?? ""));

const resolveSubdomainTenantSlug = (hostLike: string): string | null => {
  const host = normalizeHost(hostLike);
  if (!host) return null;
  if (host === "localhost" || host.endsWith(".localhost")) return null;
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return null;

  if (appRootDomain) {
    if (host === appRootDomain) return null;
    if (host.endsWith(`.${appRootDomain}`)) {
      const leftPart = host.slice(0, -(appRootDomain.length + 1));
      const slug = sanitizeTenantSlug(leftPart.split(".")[0] ?? "");
      return slug || null;
    }
    return null;
  }

  const labels = host.split(".").filter(Boolean);
  if (labels.length < 3) return null;
  const slug = sanitizeTenantSlug(labels[0] ?? "");
  return slug || null;
};

const normalizeTenantSlug = (slug: string | null | undefined) => {
  const normalized = sanitizeTenantSlug(String(slug ?? ""));
  if (!normalized) return defaultTenantSlug;
  if (normalized === defaultTenantSlug || defaultTenantAliases.has(normalized)) return defaultTenantSlug;
  return normalized;
};

export const resolveTenantSlugFromHostname = (hostLike: string | undefined | null): string => {
  const subdomain = resolveSubdomainTenantSlug(String(hostLike ?? ""));
  return normalizeTenantSlug(subdomain || defaultTenantSlug);
};

export const resolveHostSlugFromHostname = (hostLike: string | undefined | null): string => {
  const subdomain = resolveSubdomainTenantSlug(String(hostLike ?? ""));
  return sanitizeTenantSlug(String(subdomain ?? "")) || defaultTenantSlug;
};
